/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveOperations from './receive-operations';

export default (query = { page : 1, limit : 25 }) => (dispatch) => {
    dispatch({
        type: actions.OPERATIONS_REQUEST,
    });

    return cecSdk
        .operation()
        .list(query)
        .then((operations) => {
            dispatch({
                type: actions.OPERATIONS_REQUEST_SUCCESS,
            });
            dispatch(receiveOperations(operations));
            return operations;
        });
};
